import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import promoReducer from "./slices/promo-slice";
import categoryReducer from "./slices/category-slice";
import productReducer from "./slices/product-slice";

export const store = configureStore({
  reducer: {
    promo: promoReducer,
    categories: categoryReducer,
    products: productReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
